var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._b({staticClass:"btn-blue",attrs:{"is-loading":_vm.isLoading,"disabled":_vm.disabled !== undefined ? _vm.disabled : _vm.isClicked},on:{"click":_vm.click}},'BaseButton',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('general.save')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }